import styled from "styled-components";
import { Container, Section, Eyebrow } from "./ui";
import Reveal from "./Reveal";

const items = [
  {
    k: "01",
    t: "100% organike",
    d: "Vetëm vajra esencialë të certifikuar organikë. Pa aroma sintetike, pa mbushës, pa ilaçe.",
  },
  {
    k: "02",
    t: "Prodhuar në Zvicër",
    d: "Përzierjet bëhen në laborator zviceran, sipas standardeve të tyre të cilësisë.",
  },
  {
    k: "03",
    t: "Zgjat deri në 6 muaj",
    d: "Një inhalator i vetëm të shërben gjysmë viti me përdorim të rregullt.",
  },
  {
    k: "04",
    t: "Sa një stilolaps",
    d: "Hyn në xhep, në çantë ose në dorezën e makinës. E mban me vete pa e menduar.",
  },
  {
    k: "05",
    t: "E thjeshtë për t'u përdorur",
    d: "Hiqe kapakun, merr dy ose tre frymëmarrje. Nuk ka asgjë tjetër për të mësuar.",
  },
  {
    k: "06",
    t: "Edhe për fëmijë mbi 6 vjeç",
    d: "Shumica e varianteve janë të përshtatshme për fëmijë mbi gjashtë vjeç.",
  },
];

export default function Benefits() {
  return (
    <Section $alt>
      <Container>
        <Head>
          <Reveal>
            <Eyebrow>Pse Aroma Stick</Eyebrow>
            <H2>
              Gjashtë arsye të vogla
              <br />
              që bëjnë dallimin
            </H2>
          </Reveal>
        </Head>

        <Grid>
          {items.map((it, i) => (
            <Reveal key={it.k} delay={(i % 3) * 0.08}>
              <Item>
                <Num>{it.k}</Num>
                <ItemTitle>{it.t}</ItemTitle>
                <ItemText>{it.d}</ItemText>
              </Item>
            </Reveal>
          ))}
        </Grid>
      </Container>
    </Section>
  );
}

const Head = styled.div`
  margin-bottom: 56px;
  max-width: 48ch;
`;

const H2 = styled.h2`
  font-size: ${({ theme }) => theme.size.h2};
`;

const Grid = styled.div`
  display: grid;
  gap: 2px;
  grid-template-columns: 1fr;
  background: ${({ theme }) => theme.colors.line};
  border: 1px solid ${({ theme }) => theme.colors.line};
  border-radius: ${({ theme }) => theme.radius.lg};
  overflow: hidden;

  ${({ theme }) => theme.bp.sm} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${({ theme }) => theme.bp.md} {
    grid-template-columns: repeat(3, 1fr);
  }

  /* Reveal mbështjell secilin element, prandaj sfondi vendoset te fëmija. */
  & > * {
    background: ${({ theme }) => theme.colors.bgAlt};
    transition: background 0.4s ease;
  }
  & > *:hover {
    background: ${({ theme }) => theme.colors.surface};
  }
`;

const Item = styled.div`
  padding: 34px 28px 38px;
  height: 100%;

  ${({ theme }) => theme.bp.md} {
    padding: 44px 36px 48px;
  }
`;

const Num = styled.span`
  display: block;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.size.sm};
  color: ${({ theme }) => theme.colors.brand};
  letter-spacing: 0.1em;
  margin-bottom: 20px;
`;

const ItemTitle = styled.h3`
  font-size: ${({ theme }) => theme.size.xl};
  margin-bottom: 12px;
`;

const ItemText = styled.p`
  font-size: ${({ theme }) => theme.size.sm};
  color: ${({ theme }) => theme.colors.inkSoft};
  max-width: 34ch;
`;
